import { useState } from "react";
import type { AiVerdict } from "@mnp/shared";
import { formatDateTime } from "../../lib/orders";
import { usePendingPayments } from "../../lib/usePaymentsVerification";
import { PaymentDetailDrawer } from "./PaymentDetailDrawer";

// A1.1 — manual payment-verification queue. Lists every Payment parked as
// `pending_admin_review` (ambiguous AI verdict) for a bookkeeping/management
// human to approve or reject.

export const AI_VERDICT_LABELS_RU: Record<AiVerdict, string> = {
  verified: "Совпало",
  underpaid: "Недоплата",
  overpaid: "Переплата",
  rejected: "Не чек",
  ai_failed: "AI не ответил",
  duplicate: "Дубликат",
};

const VERDICT_BADGE: Record<AiVerdict, string> = {
  verified: "green",
  underpaid: "yellow",
  overpaid: "yellow",
  rejected: "red",
  ai_failed: "gray",
  duplicate: "gray",
};

// «Ozon/WB» удалён 2026-06-12 (архив: archive/ozonwb-flow, тег
// pre-ozonwb-extract); неизвестные типы рендерятся raw-строкой.
const ORDER_TYPE_LABEL: Record<string, string> = {
  shop: "Упаковка",
};

export function PaymentsVerificationLanding() {
  const [openId, setOpenId] = useState<string | null>(null);
  const { data, isLoading } = usePendingPayments();
  const rows = data ?? [];

  return (
    <div className="content">
      <div className="toolbar">
        <div className="bold" style={{ fontSize: 15 }}>
          Очередь верификации чеков
        </div>
        <span className="muted" style={{ fontSize: 12 }}>
          {rows.length} на проверке
        </span>
      </div>

      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Загружен</th>
              <th>Заказ</th>
              <th>Клиент</th>
              <th>AI-вердикт</th>
              <th className="num">Распознано</th>
              <th className="num">К оплате</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={6} style={{ padding: 40, textAlign: "center" }}>
                  Загрузка…
                </td>
              </tr>
            )}
            {!isLoading && rows.length === 0 && (
              <tr>
                <td
                  colSpan={6}
                  style={{
                    padding: 40,
                    textAlign: "center",
                    color: "var(--mnp-fg-3)",
                  }}
                >
                  Очередь пуста — нет чеков на ручной проверке
                </td>
              </tr>
            )}
            {rows.map((p) => {
              const verdict = p.aiVerdict;
              return (
                <tr
                  key={p.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => setOpenId(p.id)}
                >
                  <td className="muted">{formatDateTime(p.createdAt)}</td>
                  <td className="mono" style={{ fontSize: 11 }}>
                    {ORDER_TYPE_LABEL[p.orderType] ?? p.orderType} ·{" "}
                    {p.orderId.slice(0, 8)}
                  </td>
                  <td className="mono">{p.clientChatId}</td>
                  <td>
                    {verdict ? (
                      <span className={"badge-a " + VERDICT_BADGE[verdict]}>
                        {AI_VERDICT_LABELS_RU[verdict]}
                      </span>
                    ) : (
                      <span className="badge-a gray">—</span>
                    )}
                  </td>
                  <td className="num tnum bold">
                    {p.aiPaidAmount != null ? `${p.aiPaidAmount} GEL` : "—"}
                  </td>
                  <td className="num tnum bold">
                    {p.totalAmount != null ? `${p.totalAmount} GEL` : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {openId && (
        <PaymentDetailDrawer
          paymentId={openId}
          onClose={() => setOpenId(null)}
        />
      )}
    </div>
  );
}
